let appMode = process.env.REACT_APP_ENV;
const ASSET_URL =
  process.env.REACT_APP_ASSET_URL || "http://52.66.164.177:5000";
const URL =
  (process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_BACKEND_URL ||
    (appMode === "development"
      ? "http://localhost:8024/api/"
      : "http://localhost:8024/api/"))
    .replace(/\/+$/, "") + "/";
const socketUrl = process.env.REACT_APP_SOCKET_URL || "";
// NOTE: Imergey-AI's URL is intentionally NOT configured here anymore.
// Writing Assistant, Research/Collaboration, and Vault's AI ingestion all go
// through the Node backend (baseURL below), which proxies to Imergey-AI via
// its own IMERGEY_AI_URL env var — a single source of truth, set once on the
// backend rather than per-frontend-environment.
let apiPath = {
  baseURL: URL,
  socketUrl,
  imageUrl: process.env.REACT_APP_IMAGE_URL || ASSET_URL,
  assetURL: ASSET_URL,
  dashboard: "admin/dashboard",

  // Auth API
  logout: "admin/auth/logout",
  login: "admin/auth/login",
  currentStatus: "admin/auth/update-current-status",
  teamManager: "admin/team-manager",
  teamList: "admin/team-manager",
  adminManager: "admin/user",
  adminUserManager: "admin/users",
  profile: "admin/auth/get-profile",
  updateProfile: "admin/auth/update-profile",
  changePassword: "admin/auth/change-password",
  updateAppSetting: "admin/auth/update-app-setting",

  forgotPassword: "admin/auth/forgot-password",
  verifyOTP: "admin/auth/verify-otp",
  resetPassword: "admin/auth/reset-password",

  editSetting: "admin/setting/edit",
  viewSetting: "admin/setting/view",

  // Subscription APIs
  listSubscription: "admin/subscription/list",
  addEditSubscription: "admin/subscription/add-edit",
  statusSubscription: "admin/subscription/status",
  viewSubscription: "admin/subscription/view",
  editSubscription: "admin/subscription/edit",

  // Event APIs
  listEvent: "admin/event/list",
  addEditEvent: "admin/event/add-edit",
  statusEvent: "admin/event/status",
  viewEvent: "admin/event/view",
  venueList: "admin/event/venueList",
  tableList: "admin/event/tableList",

  // EmailTemplate APIs
  listEmailTemplate: "admin/email-template/list",
  addEditEmailTemplate: "admin/email-template/add-edit",
  statusEmailTemplate: "admin/email-template/status",
  viewEmailTemplate: "admin/email-template/view",

  // Banner APIs
  listBanner: "admin/banner/list",
  addEditBanner: "admin/banner/add-edit",
  statusBanner: "admin/banner/status",
  viewBanner: "admin/banner/view",

  // Banner APIs
  listBrand: "admin/brand/list",
  addEditBrand: "admin/brand/add-edit",
  statusBrand: "admin/brand/status",
  viewBrand: "admin/brand/view",
  importBrand: "admin/brand/import-file",

  // Content APIs
  listContent: "admin/content/list",
  editContent: "admin/content/edit",
  statusContent: "admin/content/status",
  viewContent: "admin/content/view",

  //notification
  notification: "admin/notification",
  notificationUser: "admin/notification/notification-user",

  //help-center
  helpCenter: "admin/help-center",

  //Finance Manager
  reportList: "admin/finance/report",
  cashOut: "admin/finance/cashout-request",
  bookingRefundRequest: "admin/finance/booking-refund-request",
  orderRefundRequest: "admin/finance/order-refund-request",

  //Report Manager
  userMetrics: "admin/report/metrics",
  reportBooking: "admin/report/most-booking",
  topVendorReport: "admin/report/top-vendor-report",
  reportCount: "admin/report/get-count",

  //View User
  userBooking: "admin/report/user-booking",
  userOrder: "admin/report/user-order",
  //Access Module
  getClients: "admin/access-module/get-clients",
  clientClientStatus: "admin/access-module/client-status-change",
  // Contract APIs
  contractList: "admin/contract/list",
  contractCreate: "admin/contract/create",
  contractUpdate: "admin/contract/update",
  contractMarkAsPaid: "admin/contract/mark-as-paid",
  contractDelete: "admin/contract/delete",
  contractDeletePayment: (contractId, paymentId) => `admin/contract/${contractId}/payment/${paymentId}`,
  contractByClient: "admin/contract/client",
  upcomingRenewals: "admin/contract/upcoming-renewals",
  upcomingPaymentRenewals: "admin/contract/upcoming-payment-renewals",
  expiredContracts: "admin/contract/expired-contracts",
  // Activity Log APIs
  activityLogActors: "admin/activity-log/actors",
  activityLogList: "admin/activity-log/list",
  // Per-customer pause/resume
  customerPause: "admin/customer/pause",
  // Inactivity notice
  customerNotifyInactive: "admin/customer/notify-inactive",
  // Other APIs
  customerManager: "admin/customer",
  brandManager: "admin/brand-manager",
  gamerProduct: "admin/gamer-product",
  vendermanager: "admin/vender",
  designermanager: "admin/designer",
  category: "admin/category",
  catalogue: "admin/catalogue",
  workShop: "admin/workshop",
  gamingHall: "admin/gaming-hall",
  earningMangement: "admin/earning-mangement",
  productCategory: "admin/product-category",
  productCatalogue: "admin/product",
  banner: "admin/banner",
  content: "admin/content",
  setCommission: "admin/auth/commission",
  subscription: "admin/subscription",
  booking: "admin/booking",
  order: "admin/order",
  transaction: "admin/transaction",
  getProfile: "admin/auth/get-profile",
  common: {
    userOrVendors: "common/user-or-vendor",
    vendors: "common/vendor",
    designers: "common/designer",
  },
  onboarding: {
    start: (clientId) => `admin/onboarding/start/${clientId}`,
    list: "admin/onboarding/list",
    progress: (clientId) => `admin/onboarding/progress/${clientId}`,
    status: (clientId) => `admin/onboarding/status/${clientId}`,
    resend: (clientId) => `admin/onboarding/resend-notification/${clientId}`,
    override: (clientId) => `admin/onboarding/override/${clientId}`,
    markComplete: (clientId) => `admin/onboarding/mark-complete/${clientId}`,
    manualClient: (clientId) => `admin/onboarding/manual/client/${clientId}`,
    manualBrandTask: (clientId, taskKey) => `admin/onboarding/manual/brand/${clientId}/${taskKey}`,
    manualBrandRequest: (clientId, taskKey) => `admin/onboarding/manual/brand-request/${clientId}/${taskKey}`,
    manualBrandAssignees: "admin/onboarding/manual/brand-assignees",
    brandRequestCompletion: (clientId) => `admin/onboarding/brand-request-completion/${clientId}`,
    cardViewClients: "admin/onboarding/card-view-clients",
    postingSchedule: (clientId) => `admin/onboarding/posting-schedule/${clientId}`,
  },

  // Graphics Team Portal — Admin oversight/creation
  graphicsTeamMembers: "admin/graphics/team-members",
  graphicsRequests: "admin/graphics/requests",
  graphicsRequest: (id) => `admin/graphics/requests/${id}`,
  graphicsRequestAuditLog: (id) => `admin/graphics/requests/${id}/audit-log`,
  graphicsWorkloadReport: "admin/graphics/workload-report",
  graphicsWorkloadReportExport: (memberId) => `admin/graphics/workload-report/${memberId}/export`,
  graphicsOverrideAssign: (id) => `admin/graphics/requests/${id}/override-assign`,
  graphicsRequestVersions: (id) => `admin/graphics/requests/${id}/versions`,
  graphicsRequestDeleteVersion: (id, versionId) => `admin/graphics/requests/${id}/versions/${versionId}`,
  graphicsRequestUpdateVersionNotes: (id, versionId) => `admin/graphics/requests/${id}/versions/${versionId}/notes`,
  graphicsRequestVersionDeletionDecision: (id, versionId) => `admin/graphics/requests/${id}/versions/${versionId}/deletion-decision`,
  graphicsRequestExtensionDecision: (id) => `admin/graphics/requests/${id}/extension-decision`,
  graphicsRequestComments: (id) => `admin/graphics/requests/${id}/comments`,
  graphicsRequestReviewDecision: (id) => `admin/graphics/requests/${id}/review-decision`,
  graphicsRequestUpdate: (id) => `admin/graphics/requests/${id}/details`,
  graphicsRequestComplete: (id) => `admin/graphics/requests/${id}/complete`,

  // Blog Write Team Portal — Admin oversight/creation (mirrors Graphics above)
  blogWriteTeamMembers: "admin/blog-write/team-members",
  blogWriteRequests: "admin/blog-write/requests",
  blogWriteRequest: (id) => `admin/blog-write/requests/${id}`,
  blogWriteRequestAuditLog: (id) => `admin/blog-write/requests/${id}/audit-log`,
  blogWriteWorkloadReport: "admin/blog-write/workload-report",
  blogWriteWorkloadReportExport: (memberId) => `admin/blog-write/workload-report/${memberId}/export`,
  blogWriteOverrideAssign: (id) => `admin/blog-write/requests/${id}/override-assign`,
  blogWriteRequestVersions: (id) => `admin/blog-write/requests/${id}/versions`,
  blogWriteRequestDeleteVersion: (id, versionId) => `admin/blog-write/requests/${id}/versions/${versionId}`,
  blogWriteRequestUpdateVersionNotes: (id, versionId) => `admin/blog-write/requests/${id}/versions/${versionId}/notes`,
  blogWriteRequestVersionDeletionDecision: (id, versionId) => `admin/blog-write/requests/${id}/versions/${versionId}/deletion-decision`,
  blogWriteRequestExtensionDecision: (id) => `admin/blog-write/requests/${id}/extension-decision`,
  blogWriteRequestComments: (id) => `admin/blog-write/requests/${id}/comments`,
  blogWriteRequestDeleteComment: (id, commentId) => `admin/blog-write/requests/${id}/comments/${commentId}`,
  blogWriteRequestReviewDecision: (id) => `admin/blog-write/requests/${id}/review-decision`,
  blogWriteRequestUpdate: (id) => `admin/blog-write/requests/${id}/details`,
  blogWriteRequestComplete: (id) => `admin/blog-write/requests/${id}/complete`,
  blogWriteRequestVersionHtml: (id, versionId) => `admin/blog-write/requests/${id}/versions/${versionId}/html`,
  blogWriteRequestVersionAnalyze: (id, versionId) => `admin/blog-write/requests/${id}/versions/${versionId}/analyze`,
  blogWriteRequestPromoteToBlog: (id) => `admin/blog-write/requests/${id}/promote-to-blog`,

  // Brand Manager / Brand Strategist workload reporting
  brandWorkloadBM: "admin/brand-workload/bm",
  brandWorkloadBS: "admin/brand-workload/bs",
  brandWorkloadBMExport: (memberId) => `admin/brand-workload/bm/${memberId}/export`,
  brandWorkloadBSExport: (memberId) => `admin/brand-workload/bs/${memberId}/export`,
  brandWorkloadConsolidatedExport: "admin/brand-workload/consolidated/export",
  brandRenewalRate: "admin/brand-workload/renewal-rate",
  brandRenewalRateDetail: (memberId) => `admin/brand-workload/renewal-rate/${memberId}`,
  brandRenewalRateTeam: (staffId) => `admin/brand-workload/renewal-rate/${staffId}/team`,
  brandRenewalRateExport: "admin/brand-workload/renewal-rate/export",
  brandRenewalRateExportPdf: "admin/brand-workload/renewal-rate/export/pdf",
  brandRenewalRateBMExport: (memberId) => `admin/brand-workload/renewal-rate/${memberId}/export`,
  brandRenewalRateBMExportPdf: (memberId) => `admin/brand-workload/renewal-rate/${memberId}/export/pdf`,
};

export default apiPath;
